/**
 * Returns bounding box for an Array of vertices of any length
 * @param {number[][]} vertices Vertices listed out as an array of
 * @returns  Bounding Box given by left, top, right, and bottom
 */
export function calculateBoundingBox(vertices: Array<Array<number>>): {
  left: number
  top: number
  right: number
  bottom: number
} {
  let minX = Infinity
  let maxX = -Infinity
  let minY = Infinity
  let maxY = -Infinity

  vertices.forEach((vertex) => {
    if (vertex[0] < minX) minX = vertex[0]
    if (vertex[0] > maxX) maxX = vertex[0]
    if (vertex[1] < minY) minY = vertex[1]
    if (vertex[1] > maxY) maxY = vertex[1]
  })

  return {
    left: minX,
    top: minY,
    right: maxX,
    bottom: maxY,
  }
}
